import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import '@fontsource/bebas-neue/400.css'
import '@fontsource/oswald/300.css'
import '@fontsource/oswald/400.css'
import '@fontsource/oswald/500.css'
import '@fontsource/oswald/600.css'
import '@fontsource-variable/inter'
import '@fontsource/roboto-mono/400.css'
import '@fontsource/roboto-mono/500.css'

import './styles/tokens.css'
import './styles/skin.css'

import App from './App'
import { JEST } from './build'
import { registerServiceWorker } from './pwa'

// Phase 23. Production only; see pwa.ts for why not under `vite dev`.
// Phase 26. Never under the Jest build: their rules forbid an install surface, the page is on
// their CDN, and a worker that precached the shell there would be caching somebody else's origin.
if (!JEST) registerServiceWorker()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
